module.exports = __webpack_public_path__ + "static/media/petunia.120158d4.jpg";